import React from 'react';
import { useIntl } from 'react-intl-next';
import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import { formatShortcut, toggleTaskList } from '@atlaskit/editor-common/keymaps';
import { tasksAndDecisionsMessages } from '@atlaskit/editor-common/messages';
import { ToolbarDropdownItem, ToolbarKeyboardShortcutHint, TaskIcon } from '@atlaskit/editor-toolbar';
export var TaskListMenuItem = function TaskListMenuItem(_ref) {
  var api = _ref.api;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useSharedPluginState = useSharedPluginStateWithSelector(api, ['taskDecision'], function (states) {
      var _states$taskDecisionS;
      return {
        isInsideTask: (_states$taskDecisionS = states.taskDecisionState) === null || _states$taskDecisionS === void 0 ? void 0 : _states$taskDecisionS.isInsideTask
      };
    }),
    isInsideTask = _useSharedPluginState.isInsideTask;
  var handleClick = function handleClick() {
    var _api$taskDecision;
    api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$taskDecision = api.taskDecision) === null || _api$taskDecision === void 0 ? void 0 : _api$taskDecision.commands.toggleTaskList());
  };
  return /*#__PURE__*/React.createElement(ToolbarDropdownItem, {
    elemBefore: /*#__PURE__*/React.createElement(TaskIcon, {
      size: "small",
      label: ""
    }),
    elemAfter: /*#__PURE__*/React.createElement(ToolbarKeyboardShortcutHint, {
      shortcut: formatShortcut(toggleTaskList)
    }),
    isSelected: isInsideTask,
    isDisabled: false,
    onClick: handleClick,
    ariaKeyshortcuts: formatShortcut(toggleTaskList)
  }, formatMessage(tasksAndDecisionsMessages.taskList));
};